import ftosCommitTypes from './commit-types';
import ftoModel from '../../models/fto';
import ReducerUtilities from '../../../shared/store/reducer-utilities';

const INITIAL_FTOS_STATE = {
  isLoading: [],
  list: null,
};

function ftosReducers(state = INITIAL_FTOS_STATE, action) {
  if (!action || !action.type) {
    return state;
  }
  switch (action.type) {
    case ftosCommitTypes.PUSH_FTOS:
      return {
        ...state,
        list: [...action.list.map(item => ftoModel(item))],
      };
    case ftosCommitTypes.REPLACE_FTO:
      return {
        ...state,
        list: ReducerUtilities.replaceModelInList(ftoModel(action.oit), state.list),
      };
    case ftosCommitTypes.RESET_FTOS_STATE:
      return { ...INITIAL_FTOS_STATE };
    case ftosCommitTypes.SET_FTOS_IS_LOADING:
      return {
        ...state,
        isLoading: ReducerUtilities.updateIsLoading(action.isLoading, state.isLoading),
      };
    default:
      return state;
  }
}

export default ftosReducers;
